<template>
  <div>
    <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="paymentsMethodsList"
      :items="paymentsMethodsList"
      :fields="paymentsMethodsFields"
      :filter="filter"
      @ClickOnEditButton="editItem"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="currentRowPaymentsMethods" :isEdit="isEdit"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      isEdit: null,
      currentRowPaymentsMethods: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      paymentsMethodsFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ]
    }
  },
  methods: {
    showAdd () {
      this.isEdit = false
      this.currentRowPaymentsMethods = {
        id: 0,
        name: ''
      }
      let listId = []
      for (let i in this.paymentsMethodsList) {
        listId.push(this.paymentsMethodsList[i].id)
      }
      let isMaxId = Math.max.apply(null, listId)
      if (isMaxId < 100) {
        isMaxId = 100
        this.currentRowPaymentsMethods.id = isMaxId
      } else {
        this.currentRowPaymentsMethods.id = isMaxId + 1
      }
      this.$root.$emit('bv::show::modal', 'modalEditPaymentsMethods', '#btnShow')
    },
    editItem (item) {
      this.currentRowPaymentsMethods = JSON.parse(JSON.stringify(item))
      this.isEdit = true
      this.$root.$emit('bv::show::modal', 'modalEditPaymentsMethods', '#btnShow')
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    paymentsMethodsList () {
      return this.$store.getters['ReferenceBooks/PAYMENT_METHODS']
    }
  },
  mounted () {
    this.$store.dispatch('ReferenceBooks/GET_PAYMENT_METHODS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/referenceBook/paymentsMethods/main.vue